// extracted by mini-css-extract-plugin
export default {"billingPeriodTo":"BillingPage_billingPeriodTo__i-e53"};